import React from 'react';
import {Input, TextArea, Label} from 'components';
import i18n from 'i18next';

type OpenQuestionFormProps = {
  title?: string;
  setTitle: (value: string) => void;
  feedback?: string;
  setFeedback: (value: string) => void;
  disabled?: boolean;
  isEdit?: boolean;
};

function OpenQuestionForm({
  title,
  setTitle,
  feedback,
  setFeedback,
  disabled,
  isEdit,
}: OpenQuestionFormProps) {
  return (
    <>
      <Label
        htmlFor="multiple-title"
        label={i18n.t(
          'wisbitPage.addComponentModal.openQuestionForm.titleLabel'
        )}
      >
        {!isEdit && !disabled && (
          <Input
            id="multiple-title"
            value={title}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setTitle(event.target.value)
            }
            className="mb-4"
            disabled={disabled}
          />
        )}
        {disabled && (
          <div className="mb-4">
            {i18n.t(
              'wisbitPage.addComponentModal.openQuestionForm.askInTextPart'
            )}
          </div>
        )}
        {isEdit && (
          <div className="mb-4">
            {i18n.t(
              'wisbitPage.addComponentModal.openQuestionForm.editInTextPart'
            )}
          </div>
        )}
      </Label>
      <Label
        htmlFor="multiple-feedback"
        label={i18n.t(
          'wisbitPage.addComponentModal.openQuestionForm.feedbackLabel'
        )}
      >
        <TextArea
          id="multiple-feedback"
          value={feedback}
          onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) =>
            setFeedback(event.target.value)
          }
          disabled={disabled}
        />
      </Label>
    </>
  );
}

export default OpenQuestionForm;
